/**
 * Detects whether or not the site is being viewed in PWA mode
 * (ie. as a 'Progressive Web App')
 */
export function isPWA(): boolean {
  // For iOS
    const isIOSStandalone = (window.navigator as any).standalone === true;

  // For Android and other platforms
  const isAndroidPWA = ["fullscreen", "standalone", "minimal-ui"]
    .some((displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches);

  return isIOSStandalone || isAndroidPWA;
}
